import { math } from 'polished';
import { type FC, type PropsWithChildren } from 'react';
import { useLocation } from 'react-router-dom';
import styled from 'styled-components';

import { Link } from '@littleotter/zz-legacy-components';

import { careDenProxyUrl } from '$shared/utils/proxy';

import { routes } from '../../routes';
import { useViewer } from '../../shared/contexts/Viewer';
import { NavLinks } from '../NavLinks';

const StyledLink = styled(Link)`
  position: absolute;
  top: ${({ theme }) => theme.deprecated_.sizeBasis};
  right: ${({ theme }) => theme.deprecated_.sizeBasis};
  font-size: ${({ theme }) => math(`${theme.deprecated_.sizeBasis}`)};
  z-index: 9998;
`;

const pagesWithoutNav = [routes.paymentDetails.base, routes.authOnboarding.base, routes.child.base, routes.matchList];

export const NavBar: FC<PropsWithChildren> = () => {
  const { viewer, isStaffViewer, loading } = useViewer();
  const location = useLocation();

  if (loading) return null;

  const isOnUnauthenticatedRoute = routes.terms.test(location.pathname);

  const isOnPageWithoutNav = pagesWithoutNav.some((route) => route.test(location.pathname));

  const shouldShowNavigation = !!viewer && !isOnUnauthenticatedRoute && !isOnPageWithoutNav && isStaffViewer;

  // TODO(legacy): This looks pretty bad... it doesn't render inside header so we'll either want to move this
  // or change this up some how.
  if (!shouldShowNavigation) return <StyledLink href={careDenProxyUrl}>Go to Care Den</StyledLink>;

  return <NavLinks />;
};
